module.exports = __webpack_public_path__ + "static/img/banner3.2dffc50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner3.jpg
// module id = jQUP
// module chunks = 44